export default "__VITE_ASSET__DjWUZP4H__"